import { createReducer } from "typesafe-actions";

export const CHANGE_DEVICE = "layout/CHANGE_DEVICE";

type LayoutAction = ReturnType<typeof changeDevice>;

type LayoutState = {
  device: string;
};

const initialState: LayoutState = {
  device: "",
};

const Layout = createReducer<LayoutState, LayoutAction>(initialState, {
  [CHANGE_DEVICE]: (state: LayoutState, action: any) => {
    return { ...state, device: action.payload };
  },
});

export const changeDevice = (payload: string) => ({
  type: CHANGE_DEVICE,
  payload,
});

export default Layout;
